import React, { useState } from "react";
import "./Blog.css";

const Blog = ({ title, author, date, summary, content, image }) => {
    const [showMore, setShowMore] = useState(false);

    return (
        <div className="blog-card">
            <h2>{title}</h2>
            <p className="blog-meta">
                By <b>{author}</b> on {date}
            </p>
            <p>{summary}</p>

            {showMore && (
                <div className="blog-details">
                    {image && <img src={image} alt={title} className="blog-image" />}
                    <div className="blog-content">{content}</div>
                </div>

            )}

            <button
                className="show-more-btn"
                onClick={() => setShowMore(!showMore)}
            >
                {showMore ? "Show Less" : "Show More"}
            </button>
        </div>
    );
};

export default Blog;
